import Config from "config";
import React from "react";
import { addCommas, getPropertyType } from "../common/Common";
import { COMPARE_STORE_CONTEXT } from "./CompareStore";
import "./Comparision.css";
import { useObservableState } from "./UseObservableState";
const { map } = rxjs.operators;

const pagesLink = Config.pagesLink;
const mediaURLPrefix = Config.mediaURLPrefix;
const defaultThumbnailURL = Config.defaultThumbnailURL;

function getPropertyName(property) {
  if (Object.keys(property).length === 0) return "";

  let propertyName = "";

  if (property.VillageTH && property.VillageTH !== "-") {
    propertyName = property.VillageTH;
    if (propertyName.length > 46) {
      propertyName = propertyName.slice(0, 50) + "...";
    }
  } else {
    propertyName = `${getPropertyType(property)} ${property.ProvinceName}`;
  }

  return propertyName;
}

function getPropertyImage(property) {
  const propertyMediaes = property?.PropertyMediaes?.[0];
  return `${mediaURLPrefix}${propertyMediaes?.MediaPath}`;
}

export const Comparision = () => {
  const compareStore = React.useContext(COMPARE_STORE_CONTEXT);
  const comparePropertyLength = useObservableState(
    compareStore.comparePropertyLength$
  );

  function onRemoveAllCompareProperty() {
    compareStore.removeAllCompareProperty();
  }

  return (
    <section id="comparision">
      <div className="container">
        <div className="wrapper-head">
          <div className="wraper-close show-xs">
            <i className="ic-npa ic-npa-icon-plus"></i>
          </div>
          <div className="column-l">
            <div className="box-head-l">
              <i className="ic-npa ic-npa-icon-compare"></i>
              <h2>เปรียบเทียบทรัพย์</h2>
              <span className="number-compare">
                ({comparePropertyLength}/5)
              </span>
            </div>
            <span className="text-head">
              กรุณาเลือกอย่างน้อย 2 รายการ เพื่อทำการเปรียบเทียบ
            </span>
          </div>
          <div className="column-r">
            <div className="clear-all mousePointer"><a href={void (0)} onClick={onRemoveAllCompareProperty}>ล้างข้อมูลทั้งหมด</a></div>
            <a
              disabled={comparePropertyLength < 2}
              href={pagesLink.Compare}
              className="btn-main btn-first"
              id="btn-compare"
            >
              เปรียบเทียบ
            </a>
            <div className="wraper-close">
              <i className="ic-npa ic-npa-icon-plus"></i>
            </div>
          </div>
        </div>
        <AllCardCompare />
        <div className="fixed-btn-compare show-xs">
          <a
            href={pagesLink.Compare}
            className="btn-main btn-first"
            id="btn-compare"
          >
            เปรียบเทียบ
          </a>
          <div className="clear-all mousePointer"><a href={void (0)} onClick={onRemoveAllCompareProperty}>ล้างข้อมูลทั้งหมด</a></div>
        </div>
      </div>
    </section>
  );
};

const AllCardCompare = () => {
  const compareStore = React.useContext(COMPARE_STORE_CONTEXT);
  const comparePropertyList = useObservableState(
    compareStore.getComparePropertyList
  );

  return (
    <div className="all-card-compare">
      <div className="wraper-card">
        {comparePropertyList?.map((item) => (
          <GenerateCard {...item} />
        ))}
      </div>
    </div>
  );
};

const GenerateCard = (prop) => {
  const compareStore = React.useContext(COMPARE_STORE_CONTEXT);

  const propertyName = getPropertyName(prop);
  const propertyImage = getPropertyImage(prop);

  function onRemoveCompareProperty() {
    compareStore.removeCompareProperty(prop);
  }

  return Object.keys(prop).length === 0 ? (
    <a href={pagesLink.search} className="card empty">
      <div className="icon-add">
        <i className="ic-npa ic-npa-icon-plus"></i>
      </div>
      <div className="text-add">เพิ่มทรัพย์</div>
    </a>
  ) : (
      <div className="card">
        <div className="wrap-img show-xs-inline">
          <img
            src={propertyImage}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = defaultThumbnailURL;
            }}
            alt={propertyName}
          />
        </div>
        <div className="wrapper-detail">
          <div className="wrap-detail-card">
            <div className="wrap-img hide-xs">
              <img
                src={propertyImage}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = defaultThumbnailURL;
                }}
                alt={propertyName}
              />
            </div>
            <div className="wrap-title">
              <div className="name">{propertyName}</div>
              <div className="location">
                <i className="ic-npa ic-npa-icon-pin"></i>
                <p>{`${prop.AmphurName} ${prop.ProvinceName}`}</p>
              </div>
            </div>
          </div>
          <div className="wrap-price-card">
            <div className="wrap-price">
              <div className="new-price">
                <span className="price">
                  {addCommas(
                    prop.PromotionPrice ? prop.PromotionPrice : prop.SellPrice
                  )}
                </span>
                บาท
            </div>
              {prop.PromotionPrice && (
                <div className="old-price">{addCommas(prop.SellPrice)}</div>
              )}
            </div>
            <div className="wrap-delete">
              <i
                className="ic-npa ic-delete"
                onClick={onRemoveCompareProperty}
              ></i>
            </div>
          </div>
        </div>
      </div>
    );
};
